<template>
	<div class="app-preloader-overlay">
		<v-overlay
			:model-value="modelValue"
			:contained="contained"
			:scrim="'#babfcd'"
			class="align-center justify-center"
		>
			<v-progress-circular
				color="primary"
				indeterminate
				size="64"
			></v-progress-circular>
		</v-overlay>
	</div>
</template>

<script setup>
defineProps({

	modelValue: {
		type: Boolean,
		default: false,
	},

	contained: {
		type: Boolean,
		default: false,
	},

})
</script>
